import { render, staticRenderFns } from "./FoundryVTTInstructions.vue?vue&type=template&id=66e9531a&lang=pug&"
import script from "./FoundryVTTInstructions.vue?vue&type=script&lang=ts&"
export * from "./FoundryVTTInstructions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports